import React, {Component} from 'react';

function iconify(Icon) {
  return class Iconification extends Component {
    render() {
      const {style, color, size, ...otherProps} = this.props;
      const newStyle = Object.assign(
        {},
        color && {
          color
        },
        size && {
          fontSize: size
        },
        style
      );

      return <Icon style={newStyle} {...otherProps} />;
    }
  };
}

export default iconify;
